import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DebtorDocumentTypeV2 } from '../../../_models/index';

@Component({
  selector: 'app-custom-icon-select',
  templateUrl: './custom-icon-select.component.html',
  styleUrls: ['./custom-icon-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomIconSelectComponent),
      multi: true
    }
  ]
})
export class CustomIconSelectComponent implements ControlValueAccessor {

  @Input() options: DebtorDocumentTypeV2[] = [];
  @Input() placeholder: string = "";
  @Output() selectedOption = new EventEmitter<string>();
  @Input() version: string = 'V1';
  @Input() designVersion?: string = 'V1';

  private onChange: (value: any) => void = () => { };
  private onTouch: () => void = () => { };

  isOpen: boolean = false;
  selectedValue: DebtorDocumentTypeV2 | undefined;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: DebtorDocumentTypeV2) {
    let valueChanged: string;

    if (this.version === 'V1' && typeof option !== 'string') {
      this.selectedValue = option;
      valueChanged = option.id;
    }

    this.isOpen = false;
    this.onChange(valueChanged);
    this.onTouch();
    this.selectedOption.emit(valueChanged);
  }

  writeValue(value: string): void {
    if (this.version === 'V1') {
      const selectedValueUpdated = this.options.find(el => el.id === value);
      
      if (selectedValueUpdated) {
        this.selectedValue = selectedValueUpdated;
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void { }
}
